"use strict";

/*!
 * Скрипт добавления экспресс-счета
 */

(function ($) {
  // ECMA5 strict mode
  "use strict";

  // check namespace
  $.b2b = $.b2b || {};
  var currentProduct;
  var prefixId;
  var payerId;

  // ReSharper disable once InconsistentNaming
  var ExpressBillWidget = function ExpressBillWidget() {
    var loadingIndicator = $(".catalog-loading-div");
    this.CreateExpressBill = function (e) {
      // loading start
      loadingIndicator.removeClass("ng-hide");
      loadingIndicator.addClass("ng-show");
      var productCode = $(e.currentTarget).attr("id").replace("btnCreateExpressBill_", "");
      var productHasCode = $(e.currentTarget).attr("data-hascode") === 'true';
      var ctrlProductCount = $('input[id=\'qty_' + productCode + '\']');
      var productCount = 1;
      if (ctrlProductCount.length === 1) {
        productCount = parseInt(ctrlProductCount.val(), 10);
        if (isNaN(productCount)) {
          productCount = 1;
        }
      }
      $.when(getPayers(), getProduct(productCode, productHasCode), getBillsPrefixes(productCode)).then(function (payers, product, prefixes) {
        currentProduct = product;
        // Устанавливаем количество товара по умолчанию
        product.Qty = productCount;
        if (payers != null && payers.length > 0) {
          var defaultPayers = payers.filter(function (item) {
            return item.IsDefaultPayer === true;
          });
          // Берем либо первого по умолчанию либо первого по алфавиту
          var defaultPayer = defaultPayers.length > 0 ? defaultPayers[0] : payers[0];
          payerId = defaultPayer.ClientId;
        }
        if (prefixes != null && prefixes.length > 0) {
          prefixId = getValidPrefix(prefixes);
        }
        myCreateExpressBill();

        // loading end
        loadingIndicator.removeClass("ng-show");
        loadingIndicator.addClass("ng-hide");
      });
    };
    function getValidPrefix(prefixes) {
      var incorrectPrefixes = ['рез', 'R', 'RR', 'P', 'Pr'];
      for (var i = 0; i < prefixes.length; i++) {
        var _prefixes$i;
        if (!incorrectPrefixes.includes((_prefixes$i = prefixes[i]) === null || _prefixes$i === void 0 ? void 0 : _prefixes$i.Description)) {
          return prefixes[i].BillPrefixId;
        }
      }
    }
    var myCreateExpressBill = function myCreateExpressBill() {
      var item = {
        Articul: currentProduct.Articul,
        Qty: currentProduct.Qty,
        Description: currentProduct.Description
      };
      var expressBill = {
        ExpressBillProductItem: item,
        BillPrefixId: prefixId,
        PayerId: payerId
      };
      $.ajax({
        url: "/Bill/CreateExpressBill",
        data: {
          expressBill: expressBill
        },
        type: "POST",
        dataType: "json",
        success: function success(data) {
          if (!data.Success) {
            $.b2b.toastNotificationService.showError(data.Data.message);
            return;
          }
          var queryId = parseInt(data.Data, 10);
          if (queryId > 0) {
            setTimeout(function () {
              checkQueryState(queryId, false, currentProduct.Articul);
            }, 5000);
          }
        },
        error: function error(jqXHR) {
          $.b2b.errors.showAjaxError(jqXHR);

          // loading end
          loadingIndicator.removeClass("ng-show");
          loadingIndicator.addClass("ng-hide");
        }
      });
    };
    function getPayers() {
      var d = $.Deferred();
      $.ajax({
        url: "/Request/GetClientsForUserFlat",
        type: "GET",
        dataType: "json",
        success: function success(data) {
          d.resolve(data.Data);
        },
        error: function error(jqXHR) {
          $.b2b.errors.showAjaxError(jqXHR);
          d.reject(jqXHR);
        }
      });
      return d.promise();
    }
    function getProduct(code, productHasCode) {
      return productHasCode ? getProductByCode(code) : getProductByArticle(code);
    }
    function getProductByArticle(article) {
      var d = $.Deferred();
      $.ajax({
        url: "/Products/GetProductByArticle",
        type: "POST",
        dataType: "json",
        data: {
          article: article
        },
        success: function success(data) {
          d.resolve(data.Data);
        },
        error: function error(jqXHR) {
          $.b2b.errors.showAjaxError(jqXHR);
          d.reject(jqXHR);
        }
      });
      return d.promise();
    }
    function getProductByCode(code) {
      var d = $.Deferred();
      $.ajax({
        url: "/Products/GetProductByCode",
        type: "POST",
        dataType: "json",
        data: {
          code: code
        },
        success: function success(data) {
          d.resolve(data.Data);
        },
        error: function error(jqXHR) {
          $.b2b.errors.showAjaxError(jqXHR);
          d.reject(jqXHR);
        }
      });
      return d.promise();
    }
    function getBillsPrefixes(productCode) {
      var d = $.Deferred();
      $.ajax({
        url: "/Cart/GetBillPrefixesForProduct",
        data: {
          productCode: productCode
        },
        type: "POST",
        dataType: "json",
        success: function success(data) {
          d.resolve(data.Data);
        },
        error: function error(jqXHR) {
          $.b2b.errors.showAjaxError(jqXHR);
          d.reject(jqXHR);
        }
      });
      return d.promise();
    }
    function checkQueryState(queryId, firstRun, articul) {
      $.ajax({
        url: "/Cart/GetChangeQueryStatus",
        data: {
          queryId: queryId
        },
        type: "POST",
        dataType: "json",
        success: function success(data) {
          if (data.Success) {
            var status = parseInt(data.Data.status, 10);
            if (status === 4 || status === 5 || status === 6) {
              $.b2b.toastNotificationService.showError('Команда на добавление в счёт не выполнена. Просьба обращаться по адресу <a href="mailto:b2b-info@treolan.ru">b2b-info@treolan.ru</a>');

              // loading end
              loadingIndicator.removeClass("ng-show");
              loadingIndicator.addClass("ng-hide");
              return;
            }
            if (data.Data.SpecsStatuses.some(function (o) {
              return o.Status == 5 || o.Status == 6;
            })) {
              showRequestSpecsStatuses(data.Data.SpecsStatuses);
            } else {
              $.b2b.toastNotificationService.show($("<span>\u0422\u043E\u0432\u0430\u0440 <b>".concat(articul, "</b> \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D \u0432 \u0441\u0447\u0451\u0442</span>")).html(), {
                type: "success",
                click: function click() {
                  var link = $('<a href="/Request/Positions?activeTab=billTab"  target="_blank" class="hidden" ></a>');
                  $('body').append(link);
                  link[0].click();
                  link.remove();
                }
              });
            }

            // loading end
            loadingIndicator.removeClass("ng-show");
            loadingIndicator.addClass("ng-hide");
          } else {
            $.b2b.toastNotificationService.showError(data.Data);

            // loading end
            loadingIndicator.removeClass("ng-show");
            loadingIndicator.addClass("ng-hide");
          }
        },
        error: function error(jqXHR) {
          $.b2b.errors.showAjaxError(jqXHR);

          // loading end
          loadingIndicator.removeClass("ng-show");
          loadingIndicator.addClass("ng-hide");
        }
      });
    }
  };
  $.b2b.expressBillWidget = new ExpressBillWidget();
})(jQuery);